import { RequiredFieldsLegend } from '../../../components/RequiredFieldsLegend';

interface ApprovalDetailsHeaderProps {
  headingId?: string;
  instructionText: string;
  title: string;
}

function ApprovalDetailsHeader({ headingId, instructionText, title }: ApprovalDetailsHeaderProps) {
  const baseTestId = 'approval-details-header';

  return (
    <header
      className='approval-details-header'
      data-testid={baseTestId}>
      <h1
        className='approval-details-header__title'
        data-testid={`${baseTestId}-title`}
        id={headingId}>
        {title}
      </h1>
      <p
        className='approval-details-header__instruction'
        data-testid={`${baseTestId}-instruction`}>
        {instructionText}
      </p>
      <RequiredFieldsLegend data-testid={`${baseTestId}-required-fields`} />
    </header>
  );
}

export default ApprovalDetailsHeader;
